import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Job} from '../interfaces/jobs.dto';

@Injectable({
  providedIn: 'root'
})
export class JobResource {
  private baseUrl = environment.apiUrl + '/jobs';

  constructor(private http: HttpClient) {
  }

  getJob(jobId: string) {
    return this.http.get<Job>(`${this.baseUrl}/find/${jobId}`);
  }
}
